import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Col, Form, Icon, Popconfirm, Row, Table } from 'antd';
import moment from 'moment';
import numeral from 'numeral';
import _ from 'lodash';

import * as programmeController from '../../../../../../services/api/programme';

const FormItem = Form.Item;

export class ProgrammeList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            dataSource: [],
            filteredDataSource: [],
            selectedRowKeys: []
        }
    }

    filterData() {
        const { filters, searchText } = this.props;
        const { dataSource } = this.state;

        let newDataSource = _.filter(dataSource, _.pickBy(filters, _.identity));
        newDataSource = _.filter(newDataSource, (record) => _.filter(_.map(_.values(record), (value) => value ? value.toString().toUpperCase() : ''), (value) => value.indexOf(searchText.toUpperCase()) !== -1).length !== 0);

        this.setState({ filteredDataSource: newDataSource })
    }

    fetchData() {
        programmeController.getProgrammes()
            .then((res) => res.json())
            .then((json) => {
                const dataSource = _.map(json, (record) => ({
                    ...record,
                    course_code: record.course_code ? record.course_code.name : '',
                    programme_category: record.programme_category ? record.programme_category.name : '',
                    center: record.center ? record.center.name : '',
                    institute: record.institute ? record.institute.name : ''
                }))
                this.setState({ dataSource })
            })
            .catch((err) => console.log(err))
    }

    handleRemove() {
        const { selectedRowKeys } = this.state;
        
        this.setState({ isLoading: true });
        
        programmeController.deleteProgrammes(selectedRowKeys)
            .then((res) => res.json())
            .then((json) => {
                this.fetchData();
            })
            .catch((err) => console.log(err))
    }

    componentDidMount() {
        this.fetchData();
    }

    componentDidUpdate(prevProps, prevState) {
        const { filters, searchText } = this.props;

        if (!_.isEqual(filters, prevProps.filters) || searchText !== prevProps.searchText) {
            this.filterData();
        }
    }

    renderExpandedTable(record) {
        const { is_active, tutor, programme_date, application_due_date, leads, head_count, fee, prerequisite, remarks } = record;
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 8 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 16 },
            },
        };

        return (
            <Form className="ExpandedTableForm">
                <Row gutter={32}>
                    <Col span={12}>
                        <FormItem {...formItemLayout} label="Active">
                            <span>{is_active ? 'Yes' : 'No'}</span>
                        </FormItem>
                    </Col>
                    <Col span={12}>
                        <FormItem {...formItemLayout} label="Tutor">
                            <span>{tutor}</span>
                        </FormItem>
                    </Col>
                </Row>
                <Row gutter={32}>
                    <Col span={12}>
                        <FormItem {...formItemLayout} label="Programme Date">
                            <span>{programme_date ? moment(programme_date).format('YYYY-MM-DD') : '--'}</span>
                        </FormItem>
                    </Col>
                    <Col span={12}>
                        <FormItem {...formItemLayout} label="Application Due Date">
                            <span>{application_due_date ? moment(application_due_date).format('YYYY-MM-DD') : '--'}</span>
                        </FormItem>
                    </Col>
                </Row>
                <Row gutter={32}>
                    <Col span={12}>
                        <FormItem {...formItemLayout} label="Available Place(s)">
                            <span>{`${leads.length} / ${head_count}`}</span>
                        </FormItem>
                    </Col>
                    <Col span={12}>
                        <FormItem {...formItemLayout} label="Fee">
                            <span>{numeral(fee).format('$0,0')}</span>
                        </FormItem>
                    </Col>
                </Row>
                <Row gutter={32}>
                    <Col span={12}>
                        <FormItem {...formItemLayout} label="Pre-requisites">
                            <span>{prerequisite}</span>
                        </FormItem>
                    </Col>
                    <Col span={12}>
                        <FormItem {...formItemLayout} label="Remarks">
                            <span>{remarks}</span>
                        </FormItem>
                    </Col>
                </Row>
            </Form>
        );
    }


    render() {
        const { history, filters, searchText } = this.props;
        const { dataSource, filteredDataSource, selectedRowKeys } = this.state;
        const isRowSelected = selectedRowKeys.length !== 0;
        const isFiltered = !_.isEmpty(_.pickBy(filters, _.identity)) || searchText !== '';

        const columns = [{
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            sorter: (a, b) => a.name.localeCompare(b.name),
        }, {
            title: 'Course Code',
            dataIndex: 'course_code',
            key: 'course_code',
            sorter: (a, b) => a.course_code.localeCompare(b.course_code),
        }, {
            title: 'Programme Code',
            dataIndex: 'programme_code',
            key: 'programme_code',
            sorter: (a, b) => a.programme_code.localeCompare(b.programme_code),
        }, {
            title: 'Category',
            dataIndex: 'programme_category',
            key: 'category',
            sorter: (a, b) => a.category.localeCompare(b.category),
        }, {
            title: 'Center',
            dataIndex: 'center',
            key: 'center',
            sorter: (a, b) => a.center.localeCompare(b.center),
        }, {
            title: 'Institute',
            dataIndex: 'institute',
            key: 'institute',
            sorter: (a, b) => a.institute.localeCompare(b.institute),
        }, {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            sorter: (a, b) => a.status.localeCompare(b.status),
        }, {
            title: 'Edit',
            dataIndex: 'edit',
            key: 'edit',
            align: 'center',
            render: (text, record) => (<Icon className="icon-btn" type="edit" onClick={() => history.push(`/dashboard/admin/programme/${record.id}`)} />)
        }];

        return (
            <div className="DataList">
                <div className="table-btn-gp">
                    <div className="table-btn-gp-left">
                        <button onClick={(e) => history.push('/dashboard/admin/programme/new')}>
                            <Icon type="plus"/>
                            Create
                        </button>
                    </div>
                    <div className="table-btn-gp-right">
                        <Popconfirm 
                            placement="bottom"
                            title="This action is irreversible, are you sure?" 
                            onConfirm={(e) => this.handleRemove()} 
                            okText="Yes" 
                            cancelText="No"
                        >
                            <button disabled={!isRowSelected}>
                                <Icon type="minus"/>
                                Remove
                            </button>
                        </Popconfirm>
                    </div>
                </div>
                <Table
                    size="small"
                    rowKey="id"
                    columns={columns}
                    dataSource={isFiltered ? filteredDataSource : dataSource}
                    rowSelection={{selectedRowKeys, onChange: (selectedRowKeys) => this.setState({selectedRowKeys})}}
                    expandedRowRender={(record) => this.renderExpandedTable(record)}
                />
            </div>
        );
    }
}

export default withRouter(ProgrammeList);


// WEBPACK FOOTER //
// ./src/scenes/DashboardPage/scenes/ProgrammePage/components/ProgrammeList/ProgrammeList.js